import { render, staticRenderFns } from "./ContractCard.vue?vue&type=template&id=0b9d9cf5&scoped=true"
import script from "./ContractCard.vue?vue&type=script&lang=js"
export * from "./ContractCard.vue?vue&type=script&lang=js"
import style0 from "./ContractCard.vue?vue&type=style&index=0&id=0b9d9cf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d9cf5",
  null
  
)

export default component.exports